/**
 * Checks if an object is empty (has no keys)
 * @param {Object} obj - Object to check
 * @returns {boolean} - True if object is empty or falsy
 */
export const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;

/**
 * Checks if an object has any keys
 * @param {Object} obj - Object to check
 * @returns {boolean} - True if object has keys
 */
export const hasKeys = (obj) => obj && Object.keys(obj).length > 0;
